<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="650px"
    class="migration-notice-dialog"
    :close-on-click-modal="false"
    :show-close="true"
    :center="true"
    :append-to-body="true"
  >
    <!-- 自定义标题区域 -->
    <div slot="title" class="custom-title">
      <i
        class="el-icon-message-solid"
        style="color: #762ADB; font-size: 24px; margin-right: 8px;"
      ></i>
      <span>Dear User</span>
    </div>

    <!-- 内容区域 -->
    <div class="notice-content" style="line-height: 1.8; color: #606266;">
      <p style="margin-bottom: 10px; font-weight: bold; color: #E6A23C;">
        To enhance our service, we will migrate system functions on March 23rd, 2026. After the migration, all operations will be performed via the new system URL. We apologize for any inconvenience this may cause.
      </p>


      <!-- 新系统地址卡片 -->
      <div
        style="background: #f4f4f5; padding: 12px; border-radius: 4px; margin: 12px 0;"
      >
        <p
          style="margin: 0 0 8px 0; font-weight: bold; display: flex; align-items: center;"
        >
          <img
            src="~@/assets/images/xs.png"
            style="width: 20px; height: 20px; margin-right: 4px;"
          />
          <span>New System URL:</span>
        </p>
        <a
          href="https://tms.ytoglobal.com/"
          target="_blank"
          style="color: #762ADB; text-decoration: none; word-break: break-all;"
        >
          https://tms.ytoglobal.com/
        </a>

        <p
          style="margin: 12px 0 8px 0; font-weight: bold; display: flex; align-items: center;"
        >
          <img
            src="~@/assets/images/suo.png"
            style="width: 20px; height: 20px; margin-right: 4px;"
          />
          <span>Login Methods:</span>
        </p>
        <p style="margin: 4px 0;">QR code scan , Mobile verification code,Username/password</p>
        <p style="margin: 4px 0;"></p>
        <p style="margin: 4px 0;">

        </p>
      </div>

      <!-- 注意事项卡片 -->
      <div
        style="background: #fdf6ec; border-left: 4px solid #E6A23C; padding: 10px; margin: 12px 0;"
      >
        <!-- <img  src="~@/assets/images/jg.png"> -->
        <p style="margin: 0; color: #E6A23C; font-weight: bold;">
          ⚠️ Action Required:
        </p>
        <p style="margin: 8px 0 0 0; color: #E6A23C;">
          Please log in to the new system by March 22nd, 2026 to verify that your features and access permissions are working properly.
        </p>
      </div>

      <!-- 联系人信息 -->
      <div
        style="margin-top: 18px; padding-top: 14px; border-top: 1px dashed #dcdfe6;"
      >
        <p style="margin: 0 0 10px 0; font-size: 15px; font-weight: 500;">
          Thank you for your cooperation. If you encounter any issues, please contact your account manager or reach out via DingTalk to:
        </p>

        <div style="margin-top: 10px; line-height: 2.2;">
          <p style="margin: 0; font-size: 15px;">
            Yang Zhankui (03439530)、Tian Wenjie (03500104)

          </p>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <span
      slot="footer"
      class="dialog-footer"
      style="display: flex; justify-content: end;"
    >
      <el-button
        type="reset"
        style="background: #fff; border-color: #EDEEF1; color: #514E55;"
        @click="dialogVisible = false"
      >
      cancel
      </el-button>
      <el-button
        type="primary"
        @click="handleJump"
        style="background: #762ADB; border-color: #762ADB;"
      >
      Jump immediately
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "MigrationNoticeDialog",
  data() {
    return {
      dialogVisible: false
    };
  },
  computed: {
    showCloseButton() {
      const currentDate = new Date();
      const targetDate = new Date("2026-04-01");
      console.log('currentDate', currentDate)

      // 如果当前时间在2026年4月1日之前，返回true（显示关闭按钮）
      // 否则返回false（隐藏关闭按钮）
      return currentDate < targetDate;
    }
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },
    handleJump() {
      // 关闭弹窗
      this.dialogVisible = false;

      // 跳转到指定URL
      window.location.href = 'https://tms.ytoglobal.com/';

      // 或者使用以下方式在新标签页打开
      // window.open('https://tms.ytoglobal.com/', '_blank');
    }
  }
};
</script>

<style scoped>
.custom-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
}

.notice-content {
  padding: 0 10px;
}
</style>

<style>
/* 全局样式，确保弹框居中 */
.migration-notice-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
}

.migration-notice-dialog .el-dialog {
  margin: 0 auto !important;
}

/* 确保遮罩层也支持居中 */
.el-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-overlay .el-dialog {
  margin: 0 auto !important;
  position: relative;
  top: 0;
  transform: none;
}

/* 自定义弹框样式 */
.migration-notice-dialog .el-dialog__header {
  border-bottom: 1px solid #e8e8e8;
  padding: 20px 20px 10px;
}

.migration-notice-dialog .el-dialog__body {
  padding: 20px 20px 10px;
}

.migration-notice-dialog .el-dialog__footer {
  padding: 10px 20px 20px;
  border-top: none;
  text-align: center;
}

/* 隐藏默认的标题图标 */
.migration-notice-dialog .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}
</style>
